import { Box, Stack, Typography } from "@mui/material";
import tick from "../../../asset/images/v-live-1.png";
import JoinUs from "./JoinUsButton";

export default function Support({text,prof}){
    return (
      <Box
        component="section"
        sx={{
          my: { xs: 5, md: 8 },
          mx: "auto",
          p: { xs: 2.5, sm: 3.5, md: 5 },
          borderRadius: { xs: "24px", md: "30px" },
          bgcolor: "#fff",
          border: "1px solid #e2ebf2",
          boxShadow: "0 18px 45px rgba(22, 67, 103, .09)",
        }}
      >
        <Typography
          component="h2"
          sx={{
            mb: 1,
            fontFamily: "Assistant",
            textAlign: "center",
            fontWeight: 800,
            fontSize: { xs: "1.75rem", md: "2.3rem" },
            color: "#173c5d",
          }}
        >
          למה כדאי להצטרף אלינו?
        </Typography>
        <Typography
          component="p"
          sx={{
            mt: 0,
            mb: 3.5,
            fontFamily: "Assistant",
            textAlign: "center",
            fontWeight: 600,
            fontSize: { xs: "1rem", md: "1.15rem" },
            color: "#647d91",
          }}
        >
          פשוט כי יש לנו את כל מה שבעל מקצוע ולקוח היו רוצים
        </Typography>
        <Box sx={{ maxWidth: 850, mx: "auto", mb: 3.5 }}>
          {text.supportList.map(e=>{
            return (
              <Stack
                key={e}
                direction="row"
                spacing={1.8}
                alignItems="center"
                sx={{
                  mb: 1.4,
                  p: { xs: 1.5, md: 1.8 },
                  borderRadius: "15px",
                  bgcolor: "#f8fbfd",
                  border: "1px solid #e7eff5",
                }}
              >
                <Box
                  sx={{
                    width: { xs: 52, md: 58 },
                    height: { xs: 52, md: 58 },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "14px",
                    bgcolor: "#eef8f2",
                    border: "1px solid #d9eee1",
                    flexShrink: 0,
                  }}
                >
                  <Box component="img" src={tick} alt="" sx={{ width: { xs: 42, md: 48 }, height: { xs: 42, md: 48 }, objectFit: "contain" }} />
                </Box>
                <Typography
                  component="p"
                  sx={{
                    m: 0,
                    fontSize: { xs: ".98rem", md: "1.08rem" },
                    lineHeight: 1.6,
                    fontFamily: "Assistant",
                    fontWeight: 600,
                    color: "#385b75",
                  }}
                >
                  {e}
                </Typography>
              </Stack>
            );
          })}
        </Box>
        <JoinUs prof={prof} text={"אני רוצה להירשם!"}/>
      </Box>
    );
}
